<template>
  <div>
    <h1 class="title is-4">
      施工リスト一覧
    </h1>
    <div class="field">
      <router-link class="button is-primary" to="/companies/new/register">
        新規登録
      </router-link>
    </div>
    <div class="columns is-multiline">
      <div class="column is-narrow">
        <label class="label">施工主名</label>
        <!-- <div class="control">
          <div class="select">
            <select v-model="querySearchRange" @change="searchCompanies">
              <option v-for="(value, key) in searchRanges" :key="key" :value="key">
                {{ value }}
              </option>
            </select>
          </div>
        </div> -->
        <p class="control has-icons-left has-icons-right">
          <b-input v-model.trim="queryCompanyName" type="text" icon="magnify" @input="searchCompanies" />
        </p>
      </div>
      <div class="column is-2-widescreen is-4-desktop is-narrow">
        <label class="label">業者名</label>
        <p class="control has-icons-left has-icons-right">
          <b-input v-model.trim="queryAdvertisingAgency" type="text" icon="magnify" @input="searchCompanies" />
        </p>
      </div>

      <div class="column is-2-widescreen is-4-desktop is-narrow">
        <label class="label">構造種別(1)</label>
        <div class="control has-icons-left has-icons-right">
          <multiselect
            v-model="queryIndustryType"
            track-by="key"
            label="value"
            :options="tagBox"
            :multiple="false"
            placeholder=""
            select-label="選択する"
            deselect-label="外す"
            selected-label="選択中"
            @input="searchCompanies"
          >
            <template slot="option" slot-scope="{ option }">
              <div v-if="option.$isLabel">
                {{ option.$groupLabel }}
              </div>
              <div v-else>
                {{ option.value }}
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="column is-2-widescreen is-narrow">
        <label class="label">構造種別(2)</label>
        <div class="control has-icons-left has-icons-right">
          <multiselect
            v-model="querySelectedTags"
            track-by="key"
            label="value"
            :options="tagBox"
            :multiple="true"
            placeholder=""
            select-label="選択する"
            deselect-label="外す"
            selected-label="選択中"
            @input="searchCompanies"
          >
            <template slot="option" slot-scope="{ option }">
              <div v-if="option.$isLabel">
                {{ option.$groupLabel }}
              </div>
              <div v-else>
                {{ option.value }}
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="column is-2-widescreen is-4-desktop is-narrow">
        <label class="label">電話番号</label>
        <p class="control has-icons-left has-icons-right">
          <b-input v-model.trim="queryPhoneNumber" type="text" icon="magnify" @input="searchCompanies" />
        </p>
      </div>

      <div class="column is-2-widescreen is-4-desktop is-narrow">
        <label class="label">通話期間指定</label>
        <p class="control has-icons-left has-icons-right">
          <b-datepicker v-model.trim="queryDuration" icon="magnify" range @input="searchCompanies" />
        </p>
      </div>

      <div class="column is-2-widescreen is-4-desktop is-narrow">
        <label class="label">備考</label>
        <p class="control has-icons-left has-icons-right">
          <b-input v-model.trim="queryNote" type="text" icon="magnify" @input="searchCompanies" />
        </p>
      </div>

      <div class="column is-narrow">
        <!-- Employee in-charge -->
        <label class="label">登録社員</label>
        <div class="control">
          <div class="select">
            <select v-model="queryEmployeeId" @change="searchCompanies">
              <option :value="null">
                すべて表示
              </option>
              <option v-for="(value, key) in employees" :key="key" :value="key">
                {{ value }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-narrow">
        <label class="label">状態</label>
        <div class="control">
          <div class="select">
            <select v-model="queryState" @change="searchCompanies">
              <option :value="null">
                すべて表示
              </option>
              <option v-for="(value, key) in states" :key="key" :value="key">
                {{ value }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-narrow">
        <label class="label">見込み</label>
        <div class="control">
          <div class="select">
            <select v-model="queryLikelihood" @change="searchCompanies">
              <option :value="null">
                すべて表示
              </option>
              <option v-for="(value, key) in likelihoods" :key="key" :value="key">
                {{ value }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-narrow">
        <label class="label">履歴なし</label>
        <div class="control">
          <b-checkbox v-model="queryNoHistory" size="is-medium" @input="searchCompanies" />
        </div>
      </div>

      <div class="column is-narrow">
        <label class="label" style="visibility:hidden">検索</label>
        <div class="control">
          <button class="button is-link" @click="searchCompanies">
            検索
          </button>
        </div>
      </div>
      <div class="column is-narrow">
        <label class="label" style="visibility:hidden">クリア</label>
        <div class="control">
          <button class="button is-dark" @click="clearFiltering">
            クリア
          </button>
        </div>
      </div>
    </div>
    <div class="field">
      <p>全{{ total }}件</p>
    </div>

    <b-table
      :data="companies"
      striped
    >
      <b-table-column v-slot="props" label="施工主名">
        {{ props.row.company_name }}
      </b-table-column>

      <!-- Trader name -->
      <b-table-column v-slot="props" field="shops" label="業者名">
        {{ props.row.advertising_agency }}
      </b-table-column>

      <b-table-column v-slot="props" field="shops" label="構造種別(1)">
        {{ props.row.industry_type }}
      </b-table-column>

      <b-table-column v-slot="props" field="shops" label="構造種別(2)">
        <div v-for="tag in props.row.tags" :key="tag">
          <p>{{ tags[tag] }}</p>
        </div>
      </b-table-column>

      <b-table-column v-slot="props" label="担当者">
        <div v-for="shop in props.row.shops" :key="shop.shop_id">
          <p>{{ shop.charge }}</p>
          <p v-for="n in shop.phone_blank" :key="n">
            &nbsp;
          </p>
        </div>
      </b-table-column>

      <b-table-column v-slot="props" label="電話番号" cell-class="nowrap">
        <div v-for="shop in props.row.shops" :key="shop.shop_id">
          <p v-for="phone_number in shop.phone_numbers" :key="phone_number">
            {{ phone_number | tel }}
          </p>
        </div>
      </b-table-column>

      <b-table-column v-slot="props" label="状態">
        <div v-for="shop in props.row.shops" :key="shop.shop_id">
          <p>{{ states[shop.state] }}</p>
          <p v-for="n in shop.phone_blank" :key="n">
            &nbsp;
          </p>
        </div>
      </b-table-column>

      <b-table-column v-slot="props" label="見込み">
        <div v-for="shop in props.row.shops" :key="shop.shop_id">
          <p>{{ shortLikelihoods[shop.likelihood] }}</p>
          <p v-for="n in shop.phone_blank" :key="n">
            &nbsp;
          </p>
        </div>
      </b-table-column>
    
      <b-table-column v-slot="props" label="備考">
        {{ props.row.note | truncate(10) }}
      </b-table-column>

      <b-table-column v-slot="props" label="">
        <router-link class="button is-primary is-outlined"
                     :to="{ name: 'CallHistoriesRegister', params: { call_id: 'new', company_id: props.row.company_id }}"
        >
          通話登録
        </router-link>
      </b-table-column>

      <b-table-column v-slot="props" label="">
        <router-link class="button is-info is-outlined"
                     :to="{ name: 'CompaniesDetail', params: { company_id: props.row.company_id }}"
        >
          詳細
        </router-link>
      </b-table-column>

      <b-table-column v-slot="props" label="">
        <router-link class="button is-primary is-outlined"
                     :to="{ name: 'CompaniesRegister', params: { company_id: props.row.company_id }}"
        >
          編集
        </router-link>
      </b-table-column>

      <b-table-column v-slot="props" label="">
        <button class="button is-danger is-outlined"
                @click="showModal(props.row.company_name, props.row.company_id)"
        >
          削除
        </button>
      </b-table-column>
    </b-table>
    <b-pagination
      :total="total"
      :current.sync="current"
      :order="order"
      :size="size"
      :simple="isSimple"
      :rounded="isRounded"
      :per-page="perPage"
      :range-before="rangeBefore"
      :range-after="rangeAfter"
      @change="searchCompanies"
    />
    <b-modal :active.sync="isComponentModalActive" has-modal-card>
      <delete-modal v-bind="formProps" @delete="deleteCompany(formProps.company_id)" />
    </b-modal>
  </div>
</template>

<script>
const deleteModal = {
  inheritAttrs: false,
  props: [
    'company_name',
  ],
  template: `
    <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">削除確認：{{ company_name }}</p>
    </header>
    <section class="modal-card-body">
      <div style="white-space: pre-wrap;">{{ company_name }}を削除しますか？<br>この操作は取り消せません</div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-danger" type="button" v-on:click="doDeleteCompany()">削除</button>
      <button class="button" type="button" @click="$parent.close()">閉じる</button>
    </footer>
    </div>
  `,
  methods: {
    doDeleteCompany() {
      this.$emit('delete')
    },
  },
}

import * as util from '../Util'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import dayjs from 'dayjs'

const RANGE_ALL = 1

export default {
  name: 'Companies',
  components: {
    Multiselect,
    'delete-modal': deleteModal,
  },
  data() {
    return {
      // 検索条件
      queryCompanyName: '',
      querySearchRange: RANGE_ALL,
      queryCompanyShopName: '',
      queryIndustryType: '',
      queryAdvertisingAgency: '',
      querySelectedTags: [],
      queryPhoneNumber: '',
      queryDuration: [],
      queryNote: null,
      queryEmployeeId: null,
      queryState: null,
      queryLikelihood: null,
      queryNoHistory: null,
      // 取得データ
      companies: [],
      employees: [],
      companiesEmployees: [],
      phoneNumbers: [],
      companyTags: [],
      shops: [],
      tagBox: [],
      tags: [],
      states: [],
      searchRanges: [],
      likelihoods: [],
      shortLikelihoods: [],
      shop_id: null,
      isComponentModalActive: false,
      formProps: {
        company_id: null,
        company_name: null,
      },
      // ページャー
      total: 0,
      current: 1,
      perPage: 50,
      order: '',
      size: '',
      isSimple: false,
      isRounded: false,
      rangeBefore: 3,
      rangeAfter: 3,
    }
  },
  watch: {
    queryCompanyName(newValue) {
      util.setSessionStorage('search.companies.companyName', newValue)
    },
    querySearchRange(newValue) {
      util.setSessionStorage('search.companies.querySearchRange', newValue)
    },
    queryCompanyShopName(newValue) {
      util.setSessionStorage('search.companies.queryCompanyShopName', newValue)
    },
    queryIndustryType(newValue) {
      util.setSessionStorage('search.companies.queryIndustryType', newValue)
    },
    queryAdvertisingAgency(newValue) {
      util.setSessionStorage('search.companies.advertisingAgency', newValue)
    },
    querySelectedTags(newValue) {
      util.setSessionStorage('search.companies.querySelectedTags', newValue)
    },
    queryPhoneNumber(newValue) {
      util.setSessionStorage('search.companies.queryPhoneNumber', newValue)
    },
    queryDuration(newValue) {
      util.setSessionStorage('search.companies.queryDuration', newValue)
    },
    queryNote(newValue) {
      util.setSessionStorage('search.companies.queryNote', newValue)
    },
    queryEmployeeId(newValue) {
      util.setSessionStorage('search.companies.queryEmployeeId', newValue)
    },
    queryState(newValue) {
      util.setSessionStorage('search.companies.queryState', newValue)
    },
    queryLikelihood(newValue) {
      util.setSessionStorage('search.companies.queryLikelihood', newValue)
    },
    queryNoHistory(newValue) {
      util.setSessionStorage('search.companies.queryNoHistory', newValue)
    },
  },
  created() {
    let queryCompanyName = util.getSessionStorage('search.companies.companyName')
    let querySearchRange = util.getSessionStorage('search.companies.querySearchRange')
    let queryCompanyShopName = util.getSessionStorage('search.companies.queryCompanyShopName')
    let queryIndustryType = util.getSessionStorage('search.companies.queryIndustryType')
    let queryAdvertisingAgency = util.getSessionStorage('search.companies.advertisingAgency')
    let querySelectedTags = util.getSessionStorage('search.companies.querySelectedTags')
    let queryPhoneNumber = util.getSessionStorage('search.companies.queryPhoneNumber')
    let queryDuration = util.getSessionStorage('search.companies.queryDuration')
    let queryNote = util.getSessionStorage('search.companies.queryNote')
    let queryEmployeeId = util.getSessionStorage('search.companies.queryEmployeeId')
    let queryState = util.getSessionStorage('search.companies.queryState')
    let queryLikelihood = util.getSessionStorage('search.companies.queryLikelihood')
    let queryNoHistory = util.getSessionStorage('search.companies.queryNoHistory')

    if (queryCompanyName) {
      this.queryCompanyName = queryCompanyName
    }
    if (querySearchRange) {
      this.querySearchRange = querySearchRange
    }
    if (queryCompanyShopName) {
      this.queryCompanyShopName = queryCompanyShopName
    }
    if (queryIndustryType) {
      this.queryIndustryType = queryIndustryType
    }
    if (queryAdvertisingAgency) {
      this.queryAdvertisingAgency = queryAdvertisingAgency
    }
    if (querySelectedTags) {
      this.querySelectedTags = querySelectedTags
    }
    if (queryPhoneNumber) {
      this.queryPhoneNumber = queryPhoneNumber
    }
    if (queryDuration) {
      this.queryDuration = [
        dayjs(queryDuration[0]).toDate(),
        dayjs(queryDuration[1]).toDate(),
      ]
    }
    if (queryNote) {
      this.queryNote = queryNote
    }
    if (queryEmployeeId) {
      this.queryEmployeeId = queryEmployeeId
    }
    if (queryState) {
      this.queryState = queryState
    }
    if (queryLikelihood) {
      this.queryLikelihood = queryLikelihood
    }
    if (queryNoHistory) {
      this.queryNoHistory = queryNoHistory
    }
    this.getCompanies()
  },
  methods: {
    getCompanies(page) {
      if (!Number.isInteger(page) || page < 1) {
        page = 1
      }
      let params = {
        page: page,
        items_per_page: this.perPage,
        search_range: this.querySearchRange,
        company_name: this.queryCompanyName,
        company_shop_name: this.queryCompanyShopName,
        industry_type: this.queryIndustryType !== null ? this.queryIndustryType.value : '',
        tags: this.querySelectedTags,
        phone_number: this.queryPhoneNumber,
        duration: this.queryDuration,
        note: this.queryNote,
        employee_id: this.queryEmployeeId,
        state: this.queryState,
        likelihood: this.queryLikelihood,
        no_history: this.queryNoHistory,
        advertising_agency: this.queryAdvertisingAgency
      }


      this.$http.get('/companies', {params: params}).then(response => {
        this.current = page
        this.total = response.data.total

        this.states = response.data.states
        this.searchRanges = response.data.searchRanges
        this.likelihoods = response.data.likelihoods
        this.shortLikelihoods = response.data.shortLikelihoods
        this.tagBox = response.data.tagBox
        this.tags = response.data.tags
        this.companiesEmployees = response.data.companies_employees
        this.phoneNumbers = response.data.phone_numbers
        this.employees = response.data.employees
        this.companies = response.data.companies
        this.shops = response.data.shops
        this.companyTags = response.data.companyTags
        this.companies.forEach((row) => {
          row.employees = this.companiesEmployees[row.company_id]
          row.shops = this.shops[row.company_id]
          row.tags = this.companyTags[row.company_id]
          if (row.shops) {
            row.shops.forEach((shop) => {
              shop.phone_numbers = this.phoneNumbers[shop.shop_id]
              if (shop.phone_numbers) {
                shop.phone_blank = shop.phone_numbers.length - 1
              } else {
                shop.phone_numbers = []
              }
            })
          }
        })
      })
    },
    searchCompanies(page) {
      if (!Number.isInteger(page) || page < 1) {
        page = 1
      }
      let params = {
        page: page,
        items_per_page: this.perPage,
        search_range: this.querySearchRange,
        company_name: this.queryCompanyName,
        company_shop_name: this.queryCompanyShopName,
        industry_type: this.queryIndustryType !== null ? this.queryIndustryType.value : '',
        tags: this.querySelectedTags,
        phone_number: this.queryPhoneNumber,
        duration: this.queryDuration,
        note: this.queryNote,
        employee_id: this.queryEmployeeId,
        state: this.queryState,
        likelihood: this.queryLikelihood,
        no_history: this.queryNoHistory,
        advertising_agency: this.queryAdvertisingAgency
      }

      this.$http.get('/companies/search', {params: params}).then(response => {
        this.current = page
        this.total = response.data.total
        this.companies = response.data.companies

        this.companies.forEach((row) => {
          row.employees = this.companiesEmployees[row.company_id]
          row.shops = this.shops[row.company_id]
          row.tags = this.companyTags[row.company_id]
          if (row.shops) {
            row.shops.forEach((shop) => {
              shop.phone_numbers = this.phoneNumbers[shop.shop_id]
              if (shop.phone_numbers) {
                shop.phone_blank = shop.phone_numbers.length - 1
              } else {
                shop.phone_numbers = []
              }
            })
          }
        })
      })

    },
    showModal(company_name, company_id) {
      this.formProps.company_name = company_name
      this.formProps.company_id = company_id
      this.isComponentModalActive = true
    },
    deleteCompany(company_id) {
      this.openLoading()
      this.$http.post('/companies/' + company_id + '/delete').then(() => {
        this.searchCompanies()
        this.closeLoading()
        this.$buefy.toast.open(`削除が完了しました`)
      }).catch(error => {
        console.log(error)
        this.closeLoading()
      })
      this.isComponentModalActive = false
    },
    clearFiltering() {
      this.querySearchRange = RANGE_ALL
      this.queryCompanyShopName = ''
      this.queryIndustryType = ''
      this.queryAdvertisingAgency = ''
      this.querySelectedTags = null
      this.queryPhoneNumber = ''
      this.queryDuration = null
      this.queryNote = ''
      this.queryEmployeeId = null
      this.queryState = null
      this.queryLikelihood = null
      this.queryNoHistory = null
      this.queryCompanyName = ''
      this.searchCompanies()
    },
  },
}
</script>

<style lang="scss">
//.modal-card {
//  min-width: 420px;
//}

th, td.nowrap {
  white-space: nowrap;
}
</style>
